var map = {
	"./add-circle-outline.vue": 42474,
	"./add-outline.vue": 70811,
	"./add-square-outline.vue": 59198,
	"./alert-circle-outline.vue": 68082,
	"./announcements-outline.vue": 54609,
	"./applications-fill.vue": 95173,
	"./applications-outline.vue": 87670,
	"./archive-add-outline.vue": 63922,
	"./archive-minus-outline.vue": 5172,
	"./arrow-down-outline.vue": 11230,
	"./arrow-left-1-outline.vue": 44620,
	"./arrow-left-2-outline.vue": 96175,
	"./arrow-right-1-outline.vue": 29586,
	"./arrow-right-2-outline.vue": 37478,
	"./arrow-up-outline.vue": 39331,
	"./backburger-outline.vue": 24735,
	"./bank-fill.vue": 24772,
	"./bank-outline.vue": 91239,
	"./book-fill.vue": 12335,
	"./book-outline.vue": 20087,
	"./bookmark-fill.vue": 91906,
	"./bookmark-outline.vue": 37708,
	"./box-fill.vue": 50316,
	"./box-outline.vue": 59247,
	"./calendar-outline.vue": 92198,
	"./call-outline.vue": 1485,
	"./cancel-outline.vue": 92034,
	"./chevron-down-outline.vue": 60344,
	"./chevron-left-outline.vue": 22494,
	"./chevron-right-outline.vue": 93407,
	"./chevron-up-outline.vue": 10129,
	"./circle-fill.vue": 16157,
	"./circle-outline.vue": 62505,
	"./clipboard-tick-fill.vue": 18281,
	"./clipboard-tick-outline.vue": 90891,
	"./clock-fill.vue": 41129,
	"./clock-outline.vue": 3719,
	"./close-circle-outline.vue": 18398,
	"./delete-outline.vue": 73064,
	"./disk-outline.vue": 66301,
	"./docs-outline.vue": 5024,
	"./document-copy-fill.vue": 40256,
	"./document-copy-outline.vue": 25282,
	"./document-download-outline.vue": 41400,
	"./document-edit-outline.vue": 3697,
	"./document-text-fill.vue": 81355,
	"./document-text-outline.vue": 18114,
	"./document-upload-outline.vue": 32970,
	"./documentation-outline.vue": 8764,
	"./dots-outline.vue": 46023,
	"./double-chevron-left-outline.vue": 5353,
	"./double-chevron-right-outline.vue": 4421,
	"./download-outline.vue": 68179,
	"./element-fill.vue": 28492,
	"./element-outline.vue": 26491,
	"./email-outline.vue": 59222,
	"./export-fill.vue": 30299,
	"./export-outline.vue": 31415,
	"./eye-off-outline.vue": 89429,
	"./eye-outline.vue": 47280,
	"./filter-fill.vue": 81751,
	"./filter-outline.vue": 95290,
	"./folder-add-outline.vue": 70766,
	"./folder-cross-outline.vue": 82067,
	"./folder-edit-outline.vue": 89166,
	"./folder-open-outline.vue": 87913,
	"./folder-outline.vue": 74866,
	"./forwardburger-outline.vue": 63256,
	"./global-fill.vue": 26059,
	"./global-outline.vue": 40218,
	"./hierarchy-fill.vue": 73748,
	"./hierarchy-outline.vue": 77998,
	"./home-fill.vue": 30816,
	"./home-outline.vue": 17669,
	"./hospital-outline.vue": 26465,
	"./house-fill.vue": 95960,
	"./house-outline.vue": 73450,
	"./houses-outline.vue": 68010,
	"./iconsax-menu-outline.vue": 57790,
	"./import-outline.vue": 69357,
	"./info-circle-outline.vue": 28428,
	"./info-hub-outline.vue": 63409,
	"./list-fill.vue": 15177,
	"./list-outline.vue": 38478,
	"./location-outline.vue": 32855,
	"./logout-outline.vue": 85373,
	"./magnifying-glass-outline.vue": 99246,
	"./mail-outline.vue": 49722,
	"./maximize-outline.vue": 88352,
	"./menu-down-outline.vue": 12833,
	"./menu-outline.vue": 96653,
	"./menu-up-outline.vue": 5137,
	"./message-question-fill.vue": 37367,
	"./message-question-outline.vue": 95375,
	"./messages-fill.vue": 73169,
	"./messages-outline.vue": 32647,
	"./minimize-outline.vue": 18338,
	"./minus-outline.vue": 47745,
	"./more-circle-outline.vue": 93897,
	"./more-outline.vue": 43479,
	"./more-vertical-outline.vue": 94135,
	"./move-outline.vue": 94767,
	"./note-fill.vue": 67215,
	"./note-outline.vue": 68530,
	"./notification-outline.vue": 45728,
	"./phone-outline.vue": 3828,
	"./placeholder-fill.vue": 65754,
	"./placeholder-outline.vue": 94249,
	"./plus-outline.vue": 32325,
	"./profile-user-fill.vue": 43002,
	"./profile-user-outline.vue": 22762,
	"./selectable-outline.vue": 71470,
	"./selected-outline.vue": 59301,
	"./setting-4-fill.vue": 45978,
	"./setting-4-outline.vue": 36718,
	"./setting-fill.vue": 91397,
	"./setting-outline.vue": 29568,
	"./share-outline.vue": 57987,
	"./sort-outline.vue": 70878,
	"./table-outline.vue": 13200,
	"./tag-right-outline.vue": 16290,
	"./task-square-fill.vue": 32868,
	"./task-square-outline.vue": 4761,
	"./teacher-fill.vue": 58749,
	"./teacher-outline.vue": 26451,
	"./tick-circle-fill.vue": 15054,
	"./tick-circle-outline.vue": 87899,
	"./tick-outline.vue": 5180,
	"./ticket-fill.vue": 38432,
	"./ticket-outline.vue": 21670,
	"./ticket-star-fill.vue": 40807,
	"./ticket-star-outline.vue": 20356,
	"./trash-outline.vue": 95020,
	"./user-add-fill.vue": 98190,
	"./user-add-outline.vue": 53051,
	"./user-fill.vue": 40018,
	"./user-minus-fill.vue": 24409,
	"./user-minus-outline.vue": 23341,
	"./user-octagon-fill.vue": 74984,
	"./user-octagon-outline.vue": 54349,
	"./user-outline.vue": 85026,
	"./user-tick-fill.vue": 49566,
	"./user-tick-outline.vue": 3400,
	"./video-octagon-fill.vue": 60310,
	"./video-octagon-outline.vue": 27807
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 53671;